import React from "react";

const InventoryIcon = ({ width, height, color }) => {
  return (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M26.25 0H7.5V4.5H26.25V0Z" fill="#5469F4" />
      <path d="M26.25 10.5H7.5V15H26.25V10.5Z" fill="#5469F4" />
      <path d="M26.25 21H7.5V25.5H26.25V21Z" fill="#5469F4" />
      <path d="M26.25 31.5H7.5V36H26.25V31.5Z" fill="#5469F4" />
      <path
        d="M2.25 4.5C3.49264 4.5 4.5 3.49264 4.5 2.25C4.5 1.00736 3.49264 0 2.25 0C1.00736 0 0 1.00736 0 2.25C0 3.49264 1.00736 4.5 2.25 4.5Z"
        fill="#5469F4"
      />
      <path
        d="M2.25 15C3.49264 15 4.5 13.9926 4.5 12.75C4.5 11.5074 3.49264 10.5 2.25 10.5C1.00736 10.5 0 11.5074 0 12.75C0 13.9926 1.00736 15 2.25 15Z"
        fill="#5469F4"
      />
      <path
        d="M2.25 25.5C3.49264 25.5 4.5 24.4926 4.5 23.25C4.5 22.0074 3.49264 21 2.25 21C1.00736 21 0 22.0074 0 23.25C0 24.4926 1.00736 25.5 2.25 25.5Z"
        fill="#5469F4"
      />
      <path
        d="M2.25 36C3.49264 36 4.5 34.9926 4.5 33.75C4.5 32.5074 3.49264 31.5 2.25 31.5C1.00736 31.5 0 32.5074 0 33.75C0 34.9926 1.00736 36 2.25 36Z"
        fill="#5469F4"
      />
    </svg>
  );
};

export default InventoryIcon;
